export default "__VITE_ASSET__DC0p_9i2__"